import React, { useState } from "react";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Navbar from "../web-pages/Navbar";
import AffiliateSideNav from "./SideNav";

function AffiliateHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const toggleDrawer = () => setMobileOpen((open) => !open);

  return (
    <div className="navigation">
      {isMobile && (
        <IconButton
          aria-label="Open affiliate navigation menu"
          onClick={toggleDrawer}
          sx={{
            position: "fixed",
            top: { xs: 72, sm: 80 },
            left: 12,
            zIndex: 1200,
            bgcolor: "#151821",
            color: "#fff",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            boxShadow: "0 4px 14px rgba(0, 0, 0, 0.18)",
            "&:hover": { bgcolor: "#1f2430" },
          }}
        >
          <MenuIcon />
        </IconButton>
      )}
      <Navbar />
      <AffiliateSideNav
        mobileOpen={mobileOpen}
        handleDrawerToggle={toggleDrawer}
      />
    </div>
  );
}

export default AffiliateHeader;
